import React, { useState } from 'react';
import styled from 'styled-components';

import { primaryColor } from '~theme';

import { Modal, ModalWrapper } from '~ui-kit';

const ConfirmationModal = ({
  children,
  content,
  title,
  submit,
  headerIcon,
  ...props
}) => {
  const [show, setShow] = useState(false);

  const toggle = () => setShow(!show);

  return (
    <>
      <div onClick={toggle}>{children}</div>
      <Modal show={show} onHide={toggle}>
        <ModalWrapper
          {...props}
          close={toggle}
          title={title}
          backText="Ei"
          backOnClick={toggle}
          confirmText="Kyllä"
          confirmOnClick={() => {
            submit();
            toggle();
          }}
          headerLargeIcon={headerIcon}
        >
          <ContentWrapper>{content || 'Oletko varma?'}</ContentWrapper>
        </ModalWrapper>
      </Modal>
    </>
  );
};

const ContentWrapper = styled.div`
  color: ${primaryColor};

  & > * {
    margin-bottom: 24px;
  }
`;

export default ConfirmationModal;
